import { isNull } from "lodash";

const getSelectedRestaurants = (coords, currentFilters) => {
  if (!isNull(currentFilters)) {
    let sum = 0;
    coords.forEach(item => {
      sum = sum + parseInt(item.count);
    });
    return sum;
  } else {
    return null;
  }
};
export default getSelectedRestaurants;
